export const updateArrayById = (array, id) => (fn) => array.map((item) => (item.id !== id ? item : fn(item)));

export const updateArrayKey = (array, key) => (fn) => array.map((item, itemKey) => (itemKey !== key ? item : fn(item)));

export const removeKeyObject = (removeKey, { [removeKey]: _, ...rest }) => rest;
